import { z } from "zod";
import {
  booleanFromString,
  optionalTrimmedString,
  requiredString,
} from "./primitives";

export const registerPayloadSchema = z.object({
  email: requiredString("Email"),
  password: requiredString("Password"),
  name: optionalTrimmedString,
});

export const loginPayloadSchema = z.object({
  email: requiredString("Email"),
  password: requiredString("Password"),
  rememberMe: booleanFromString.optional(),
});

export const mfaChallengeSchema = z.object({
  email: requiredString("Email"),
  code: requiredString("Verification code"),
  session: requiredString("Session"),
  rememberMe: booleanFromString.optional(),
});

export const newPasswordChallengeSchema = z.object({
  email: requiredString("Email"),
  newPassword: requiredString("New password"),
  session: requiredString("Session"),
  rememberMe: booleanFromString.optional(),
});

export const totpConfirmSchema = z.object({
  code: z.string().regex(/^\d{6}$/, "Enter the six-digit verification code."),
  setupId: z.string().uuid(),
}).strict();
export const totpSetupResponseSchema = z.object({ secret: z.string().min(16), otpauth: z.string().startsWith("otpauth://totp/"), setupId: z.string().uuid(), expiresAt: z.string().datetime() }).strict();

export const recoveryCodeSchema = z.object({
  email: requiredString("Email"),
  code: requiredString("Recovery code"),
  rememberMe: booleanFromString.optional(),
});

export const confirmSignupSchema = z.object({
  email: requiredString("Email"),
  code: requiredString("Verification code"),
});

export const resendSignupSchema = z.object({
  email: requiredString("Email"),
});

export const forgotPasswordSchema = z.object({
  email: z.string().trim().min(1, "Email is required."),
});

export const resetPasswordSchema = z.object({
  email: z.string().trim().min(1, "Email is required."),
  code: z.string().trim().min(1, "Verification code is required."),
  newPassword: z.string().min(8, "New password must be at least 8 characters."),
});

export const refreshTokenSchema = z.object({
  refreshToken: requiredString("Refresh token").optional(),
});

export type RegisterPayload = z.infer<typeof registerPayloadSchema>;
export type LoginPayload = z.infer<typeof loginPayloadSchema>;
export type MfaChallengePayload = z.infer<typeof mfaChallengeSchema>;
export type NewPasswordChallengePayload = z.infer<typeof newPasswordChallengeSchema>;
export type TotpConfirmPayload = z.infer<typeof totpConfirmSchema>;
export type RecoveryCodePayload = z.infer<typeof recoveryCodeSchema>;
export type ConfirmSignupPayload = z.infer<typeof confirmSignupSchema>;
export type ResendSignupPayload = z.infer<typeof resendSignupSchema>;
export type ForgotPasswordPayload = z.infer<typeof forgotPasswordSchema>;
export type ResetPasswordPayload = z.infer<typeof resetPasswordSchema>;
export type RefreshTokenPayload = z.infer<typeof refreshTokenSchema>;

export const authenticatorStatusSchema = z.object({
  enabled: z.boolean(), preferred: z.enum(["totp", "sms"]).optional(), emailSignInReady: z.boolean(),
  setupId: z.string().uuid().optional(),
  setupState: z.enum(["idle", "pending", "synchronizing", "ready", "disabling"]),
}).strict();
